import { useEffect } from "react";

const BASE = "EuropEdu";

/** Sets a unique document title, description and canonical URL for each public page. */
export const usePageMeta = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : `${BASE} | Careers, Education, Recruitment and Immigration Services`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.origin + window.location.pathname);
  }, [title, description]);
};

export default usePageMeta;
